import React, { useEffect, createElement } from 'react';
import { CheckCircle, Calendar, Clock, ShieldCheck } from 'lucide-react';
export function WebinarLandingPage() {
  // Handle WebinarGeek script injection
  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    // Define the script content
    const scriptContent = `
      (function(w,d,stn,sa,gn,se,fse){w[gn]=w[gn]||function(){(w[gn].q = w[gn].q||[]).push(arguments)}; se=d.createElement(stn);fse=d.getElementsByTagName(stn)[0];se.id=gn;se.async=1; se.src=sa+"?t="+new Date().toISOString().slice(0, -9);fse.parentNode.insertBefore(se, fse); })(window, document, "script", "https://malong.webinargeek.com/malong.embed.js", "mw_IRZ9XkyoUP1" ); mw_IRZ9XkyoUP1("init", { project: "registration", identifier: "8cb0da66-aa85-471a-972d-fb072fc93d6e", shape: "inline", theme: "light" });
    `;
    script.innerHTML = scriptContent;
    script.async = true;
    // Append to body or specific container
    document.body.appendChild(script);
    // Cleanup
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  // Scroll to registration form
  const scrollToForm = () => {
    const formElement = document.getElementById('register');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-brand-navy selection:bg-brand-mint selection:text-brand-navy" data-id="element-2">
      {/* Navigation / Logo Area */}
      <nav className="w-full py-6 px-4 md:px-8 flex justify-center border-b border-gray-100 bg-white sticky top-0 z-50" data-id="element-3">
        <div className="flex items-center gap-2" data-id="element-4">
          <img src="https://cdn.magicpatterns.com/uploads/n7c6Nu1gSt6VmQBg3XhTUe/Logo_SD_(3).png" alt="Stressless Dogs" className="h-12 md:h-16 w-auto" data-id="element-5" />
        </div>
      </nav>

      {/* Hero Section */}
      <header className="relative w-full py-8 md:py-12 px-4 overflow-hidden" data-id="element-6">
        {/* Background decoration */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30" data-id="element-7">
          <div className="absolute -top-20 -right-20 w-96 h-96 bg-brand-mint rounded-full blur-3xl" data-id="element-8"></div>
          <div className="absolute top-40 -left-20 w-72 h-72 bg-blue-50 rounded-full blur-3xl" data-id="element-9"></div>
        </div>

        <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-mint/30 text-brand-navy font-semibold text-sm mb-2" data-id="element-11">
            <span className="relative flex h-3 w-3" data-id="element-12">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-coral opacity-75" data-id="element-13"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-brand-coral" data-id="element-14"></span>
            </span>
            Gratis Live Webinar
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold leading-tight text-brand-navy" data-id="element-15">
            Wat eet je hond nu écht?
          </h1>

          <p className="text-xl md:text-2xl text-brand-navy/80 font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-16">
            Ontdek wat er werkelijk in je hondenvoer zit - en waarom 84% van de
            baasjes misleid wordt door slimme marketing
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4 text-sm font-medium text-gray-600" data-id="element-17">
            <div className="flex items-center gap-2" data-id="element-18">
              <Calendar className="w-5 h-5 text-brand-turquoise" data-id="element-19" />
              <span data-id="element-20">Dinsdag 20 jan 20:00</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-21"></div>
            <div className="flex items-center gap-2" data-id="element-22">
              <Clock className="w-5 h-5 text-brand-turquoise" data-id="element-23" />
              <span data-id="element-24">90 minuten</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-gray-300 rounded-full" data-id="element-25"></div>
            <div className="flex items-center gap-2" data-id="element-26">
              <ShieldCheck className="w-5 h-5 text-brand-turquoise" data-id="element-27" />
              <span data-id="element-28">100% Gratis deelname</span>
            </div>
          </div>

          {/* CTA Button above the fold */}
          <div className="pt-6" data-id="element-29">
            <button onClick={scrollToForm} className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-brand-coral rounded-full hover:bg-brand-coral/90 transition-colors shadow-lg hover:shadow-xl transform hover:scale-105 transition-transform" data-id="element-30">
              Ja, aanmelden voor webinar
            </button>
          </div>
        </div>
      </header>

      {/* Main Content Section */}
      <main className="max-w-4xl mx-auto px-4 pb-20" data-id="element-31">
        {/* Intro Text - Centered */}
        <div className="text-center max-w-3xl mx-auto mb-12 space-y-4" data-id="element-32">
          <p className="text-xl text-brand-navy/90 leading-relaxed" data-id="element-33">
            Je wilt het beste voor je hond. Maar weet je eigenlijk wat er écht
            in zijn eten zit?
          </p>
          <p className="text-lg text-brand-navy/80 leading-relaxed" data-id="element-34">
            De meeste eigenaren kiezen voeding op basis van mooie verpakkingen,
            claims als "natuurlijk" of "met kip", en adviezen van de dierenarts.
            Maar vaak zit er heel iets anders in dit voer dan je zou denken.
          </p>
          <p className="text-lg font-semibold text-brand-coral pt-4" data-id="element-35">
            In dit gratis webinar ontdek je:
          </p>
        </div>

        {/* Benefits List - Card Style */}
        <div className="bg-gray-50 rounded-3xl p-8 md:p-10 border border-gray-100 shadow-sm mb-16" data-id="element-36">
          <ul className="space-y-6" data-id="element-37">
            {['Hoe je een voeretikel écht leest (en welke trucs fabrikanten gebruiken)', 'Wat het betekent als er "vlees 30%" op een verpakking staat (spoiler: het is niet wat je denkt)', 'Wat een hond vanuit zijn natuur minimaal nodig heeft (en waarom dat vaak mis gaat)', 'Waarom "graanvrij" niet automatisch beter is', 'Een eerlijke prijsvergelijking: wat betaal je per dag - en waarvoor?', 'Stel al je vragen tijdens de live 30 minuten vraag-en-antwoord'].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-38">
                <div className="flex-shrink-0 mt-1" data-id="element-39">
                  <CheckCircle className="w-6 h-6 text-brand-turquoise fill-brand-turquoise/10" data-id="element-40" />
                </div>
                <span className="text-lg text-brand-navy font-medium" data-id="element-41">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Speaker Section */}
        <div className="flex flex-col items-center text-center mb-16" data-id="element-42">
          <div className="relative mb-6" data-id="element-43">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-full border-4 border-brand-mint overflow-hidden shadow-lg relative z-10 bg-gray-200" data-id="element-44">
              <img src="https://cdn.magicpatterns.com/uploads/2UwpTDSfBHHHJQXbYU6WKq/Ontwerp_zonder_titel_(65).png" alt="Shelley Lansbergen – de Bruin" className="w-full h-full object-cover" data-id="element-45" />
            </div>
            {/* Decorative elements behind photo */}
            <div className="absolute -bottom-2 -right-2 w-12 h-12 bg-brand-turquoise rounded-full opacity-20 z-0" data-id="element-46"></div>
            <div className="absolute -top-2 -left-2 w-8 h-8 bg-brand-coral rounded-full opacity-20 z-0" data-id="element-47"></div>
          </div>

          <h3 className="text-xl font-heading font-bold text-brand-navy mb-1" data-id="element-48">
            Gepresenteerd door
          </h3>
          <p className="text-lg font-medium text-brand-navy/80" data-id="element-49">
            Shelley Lansbergen – de Bruin
          </p>
          <p className="text-brand-coral font-semibold text-sm uppercase tracking-wide mt-2" data-id="element-50">
            Gecertificeerd Voedingsadviseur
          </p>
        </div>

        {/* Registration Form Section */}
        <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden" id="register" data-id="element-51">
          <div className="bg-brand-navy p-6 text-center" data-id="element-52">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-53">
              Meld je gratis aan
            </h2>
            <p className="text-brand-mint mt-2" data-id="element-54">
              Beperkt aantal plaatsen beschikbaar
            </p>
          </div>

          <div className="p-6 md:p-10 bg-white" data-id="element-55">
            {/* WebinarGeek Container */}
            <div id="mw_IRZ9XkyoUP1_webinargeek" className="w-full min-h-[300px] flex justify-center" data-id="element-56"></div>

            <div className="mt-6 text-center text-sm text-gray-400" data-id="element-57">
              <p data-id="element-58">Je gegevens zijn veilig. Wij houden ook niet van spam.</p>
            </div>
          </div>
        </div>
      </main>

      {/* Sticky Mobile CTA Button */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-gray-200 shadow-lg md:hidden z-40" data-id="element-59">
        <button onClick={scrollToForm} className="w-full py-4 text-lg font-semibold text-white bg-brand-coral rounded-full hover:bg-brand-coral/90 transition-colors shadow-lg" data-id="element-60">
          Ja, aanmelden voor webinar
        </button>
      </div>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-200 py-12 mb-20 md:mb-0" data-id="element-61">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-62">
          <div className="flex justify-center mb-4" data-id="element-63">
            <img src="https://cdn.magicpatterns.com/uploads/n7c6Nu1gSt6VmQBg3XhTUe/Logo_SD_(3).png" alt="Stressless Dogs" className="h-16 w-auto" data-id="element-64" />
          </div>
          <p className="text-gray-500 text-sm" data-id="element-65">
            &copy; {new Date().getFullYear()} Stressless Dogs. Alle rechten
            voorbehouden.
          </p>
        </div>
      </footer>
    </div>;
}